import { CLASSIC_EVENT } from 'containers/constants';
import { useField } from 'react-final-form';

export function useUpdateSeance() {
  const atelierField = useField('atelier');
  const skipFromVolumeField = useField('skipFromVolume');
  const eventTemplateEnabledField = useField('eventTemplate.enabled');

  return ({
    value,
    onChange,
  }: {
    value: string;
    onChange: (value: string) => void;
  }) => {
    // Reset options if not classic
    if (value !== CLASSIC_EVENT) {
      atelierField.input.onChange(false);
      skipFromVolumeField.input.onChange(false);
      eventTemplateEnabledField.input.onChange(false);
    }
    onChange(value);
  };
}
